export default function InternalServerError() {
    return (
        <div className='flex-1 d-flex justify-content-center align-items-center'>
            <span className="fs-1 me-2">500</span><span className="fs-5">Error interno del servidor.</span>
        </div>
    )
}